import RouterSection from '@/Layout/components/RouterSection';

export default {
	path: '/',
	name: 'cs_home',
	component: RouterSection,
	mode: 'history',
	children: [
		{
			path: 'giftishow',
			name: 'giftishow',
			component: () => import('@/views/cs/Giftishow'),
			props: true,
		},
		{
			path: 'notice',
			name: 'notice',
			component: () => import('@/views/cs/notice/Notice'),
		},
		// 공지사항 상세
		{
			path: 'noticeview',
			name: 'noticeview',
			component: () => import('@/views/cs/notice/NoticeView'),
		},
		// 자주하는질문
		{
			path: 'faq',
			name: 'faq',
			component: () => import('@/views/cs/faq/Faq'),
		},
		// 자주하는질문 상세
		{
			path: 'faqview',
			name: 'faqview',
			component: () => import('@/views/cs/faq/FaqView'),
		},
		// 1:1문의
		{
			path: 'qna/:tp?',
			name: 'qna',
			component: () => import('@/views/cs/qna/Qna'),
			beforeEnter: defaultFaqParamsChk,
		},
		// 1:1문의 상세
		{
			path: 'qnaview',
			name: 'qnaview',
			component: () => import('@/views/cs/qna/QnaView'),
		},
		// 1:1문의 쓰기
		{
			path: 'qnawrite',
			name: 'qnawrite',
			component: () => import('@/views/cs/qna/QnaWrite'),
			meta: { noCache: true },
		},
		// 이용안내 목록
		{
			path: 'serviceguidelist',
			name: 'serviceguidelist',
			component: () => import('@/views/cs/Serviceguidelist'),
		},
		// 이용안내 상세
		{
			path: 'serviceguideview',
			name: 'serviceguideview',
			component: () => import('@/views/cs/Serviceguideview'),
		},

		/* 2023.07.17 서비스 가이드 버튼 주석처리 gs.song */
		// 서비스 가이드
		// {
		// 	path: 'bizguide',
		// 	name: 'bizguide',
		// 	component: () => import('@/views/cs/BizGuideView.vue'),
		// },
	],
};

function defaultFaqParamsChk(to, from, next) {
	if (!to.params.tp) {
		const defaultParams = 'ALL';
		/* faq페이지 내에서 파라미터로 탭 구분용 url 사용자 입력으로 없을 경우 파라미터 추가 후 리다이렉트 */
		const route = {
			name: 'qna',
			params: {
				...to.params,
				tp: to.params.tp || defaultParams,
			},
		};
		return next(route);
	}
	next();
}
